import React, { useEffect, useState } from 'react'
import List from '../../../components/CompanyAdmin/userManagement/listuser'
import { v2_user_list, v2_user_status_update } from '../../../actions/v2/user_management'
const Listuser = () => {

    const [list, setList] = useState(null)
    const [count, setCount] = useState(null)
    const [currentPage, setCurrentPage] = useState(1)
    const [refresh, setRefresh] = useState(false)

    const onChangeStatus = (model) => {
        v2_user_status_update(model).then((res) => {
            if (res.status) {
                setList(list.map((item) => {
                    if (item.USER_ID === model.USER_ID) {
                        item.STATUS = model.STATUS
                    }
                    return item
                }))
            }
        })
    }
    useEffect(() => {
        v2_user_list(currentPage).then((res) => {
            if (res.status) {
                setList(res.result.list)
                setCount(res.result.TOTAL)

            }
        })
    }, [currentPage, refresh])

    return (
        <React.Fragment>
            <List
                list={list}
                count={count}
                refresh={refresh}
                setRefresh={setRefresh}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
                onChangeStatus={onChangeStatus}
            />
        </React.Fragment>
    )
}

export default Listuser